<template>
    <div class="overflow-hidden rounded-3xl bg-white bg-right bg-no-repeat px-6 py-6 md:px-10 md:py-10">
        <div class="border-b border-[#d8dde3] pb-5 md:pb-6">
            <h2 class="text-xl font-semibold text-[#193549] md:text-2xl">
                {{ title }}
            </h2>
        </div>

        <div class="flex flex-col gap-5 pt-6 md:flex-row md:items-start md:gap-8">
            <div class="flex items-center gap-5">
                <div class="flex h-28 w-28 shrink-0 items-center justify-center rounded-3xl bg-[#f3f5f7] p-3 relative">
                    <component
                        v-if="!icons.length && icon"
                        :is="icon"
                        class="block h-28 w-28 max-h-full max-w-full shrink-0"
                    />

                    <transition name="fade" mode="out-in">
                        <component
                            v-if="icons.length"
                            :key="activeIndex"
                            :is="icons[activeIndex]"
                            class="block h-28 w-28 max-h-full max-w-full shrink-0"
                        />
                    </transition>
                </div>
                <p class="md:hidden mb-2 text-xs text-[#7d8b97] md:text-base font-medium">
                    {{ description }}
                </p>
            </div>

            <div class="flex-1">
                <p class="max-md:hidden mb-2 text-xs text-[#7d8b97] md:text-base font-medium">
                    {{ description }}
                </p>
                <slot/>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount} from 'vue'

const props = defineProps({
    title: String,
    description: String,
    icon: [Object, Function],
    icons: {
        type: Array,
        default: () => [],
    },
})

const activeIndex = ref(0)
let interval = null

onMounted(() => {
    if (props.icons.length > 1) {
        interval = setInterval(() => {
            activeIndex.value =
                (activeIndex.value + 1) % props.icons.length
        }, 3000)
    }
})

onBeforeUnmount(() => {
    if (interval) clearInterval(interval)
})
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
